/**
* Created by ferto
* Marciano Digital Agency
* www.marciano.com.mx
* Date: 15/03/2018.
*
* designer-question-panel Component
*/
<template>
  <div class="designer-question-panel">
    <designer-toggle-panel title="Datos Generales">
      <el-form
        label-position="top"
        :rules="rules"
        :model="item"
        class="form-wrapper"
      >
        <el-form-item
          label="Pregunta"
          prop="name"
        >
          <el-input
            ref="descriptionInput"
            v-model="item.name"
            type="textarea"
            :autosize="true"
          />
        </el-form-item>
        <el-form-item>
          <el-switch
            v-model="item.evidenceRequired"
            active-text="Evidencia requerida"
          />
        </el-form-item>
        <el-form-item
          label="Descripción"
          prop="description"
        >
          <wysiwyg
            :options="editorOptions"
            placeholder="Ingrese la descripción de la pregunta"
            v-model="item.description"
          />
          <span class="input-helper">
            Escriba una descripción que ayude a entender mejor la pregunta.
          </span>
        </el-form-item>
        <el-form-item
          label="Ayuda"
          prop="helper"
        >

          <wysiwyg
            :options="editorOptions"
            placeholder="Ingrese la ayuda de la pregunta"
            v-model="item.helper"
          />
          <span class="input-helper">La ayuda, permite desplegar un texto en la parte lateral de la pregunta</span>
        </el-form-item>
      </el-form>
    </designer-toggle-panel>
    <designer-toggle-panel title="Respuestas">
      <designer-answers-panel
        :branch-types="branchTypes"
        :question-type="item.type"
        v-model="item.$answers"
      />
    </designer-toggle-panel>
  </div>
</template>

////////////////////////////////////////////
//                                  SCRIPT
////////////////////////////////////////////
<script>
import DesignerTogglePanel from './designer-toggle-panel'
import QuestionModel from '../api/question.model'
import DesignerAnswersPanel from '@/modules/designer/_shared/designer-answers-panel'

export default {
  name: 'DesignerQuestionPanel',
  components: { DesignerAnswersPanel, DesignerTogglePanel },
  props: {
    branchTypes: {
      type: Array,
      required: true,
      default () {
        return []
      }
    },
    item: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      rules: QuestionModel.rules,
      editorOptions: {
        hideModules: {
          justifyLeft: true,
          justifyCenter: true,
          justifyRight: true,
          headings: true,
          link: true,
          code: true,
          orderedList: true,
          unorderedList: true,
          image: true,
          table: true,
          removeFormat: true
        }
      }
    }
  },
  watch: {
    item () {
      console.log('Question Descriptiono Focus')
      this.$refs.descriptionInput.focus()
    }
  },
  mounted () {
    this.model = this.item
  },
  methods: {
    onUpdate (value) {
      this.$emit('update:item', value)
    }
  }
}
</script>

////////////////////////////////////////////
//                                   STYLE
////////////////////////////////////////////
<style
  lang="scss"
  scoped
>
.designer-question-panel {
  .form-wrapper {
    display: block;
    padding: 20px;
  }
}
</style>



// WEBPACK FOOTER //
// src/modules/designer/_shared/designer-question-panel.vue